module.exports = require('./dist/theater.js')



/*****************
 ** WEBPACK FOOTER
 ** ./~/theaterjs/index.js
 ** module id = 321
 ** module chunks = 1
 **/